import i18n, { TFunctionKeys, TFunctionResult } from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import LanguageDetector, { DetectorOptions } from 'i18next-browser-languagedetector'
import missingKeyHandler from 'translations/missingKeyHandler'

type Language = 'fr' | 'en'
const options: DetectorOptions = {
  order: ['navigator', 'localStorage', 'querystring']
}

// We can't use the variable from utilities here since it's not defined yet.
const isProd = process.env.NODE_ENV === 'production' && !window.Cypress

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `https://cdn.simplelocalize.io/f2fada5a1ed44783a24dc244662af026/${isProd ? '_production' : '_latest'}/{{lng}}/{{ns}}`
    },
    ns: ['legacy'],
    // This is set to false since simplelocalize adds fallbacks directly to the json.
    fallbackLng: false,
    interpolation: { escapeValue: false },
    saveMissing: !isProd,
    missingKeyHandler,
    load: 'languageOnly',
    detection: options
  })

// Exports the t function that is internal to i18n
// the ...args makes sure all arguments passed are actually passed to the internal function
export const t = (...args: [translation: TFunctionResult, opt?: TFunctionResult]): string => i18n.t(...(args as [string, TFunctionKeys]))

export const changeLang = async (lang: Language): Promise<void> => {
  await setLanguage(lang)
}

export const setLanguage = async (lang: Language): Promise<void> => {
  await i18n.changeLanguage(lang)
}

export default i18n

export const currentLang = (upperCase?: boolean): string => {
  // Get the current language from i18n
  let currentLang = i18n.language ?? 'en'

  // If the language is in an other format then ours (en-CA, fr-CA, etc) parse it to one of our format
  if (currentLang.includes('-')) currentLang = currentLang.split('-')[0]
  // Return the language in lowercase
  if (!upperCase) return currentLang.toLowerCase()
  // Return in upperCase
  return currentLang.toUpperCase()
}
